import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LogoutOutlined } from '@ant-design/icons';
import LanguageSelector from 'src/components/language-selector';
import ReportsSelector from 'src/components/reports-selector';
import * as loginApi from 'src/apis/login';
import NotificationIcon from '../notification-icon';
import './style.scss';
import openGlobalAuth from 'src/utils/global-auth';
import FontSizeChanger from 'src/components/font-size-changer';
import CITLogo from 'src/assets/img/logoNew.svg'

/**
 * Header component.
 *
 * @returns {JSX.Element} The Header component.
 * @example
 *  <Header />
 */
function Header() {
	const sessionUser = useSelector((state) => state.login.sessionUser);
	const isSessionUserTI = sessionUser.profile === 'TI';
	const isSessionUserBP = sessionUser.profile === 'BP';
	const canSeeResponsible = isSessionUserTI || sessionUser.profile === 'ADM';
	const { t } = useTranslation();

	/**
	 * Remove code-verifier and token values upon logout.
	 */
	function onLogout() {
		loginApi
			.logout()
			.then((_response) => {
				localStorage.removeItem('code-verifier');
				openGlobalAuth();
				console.info("User logged out!");
			})
			.catch((err) => {
				console.error("Error on logout user.", err);
				localStorage.removeItem('code-verifier');
				window.location.href = '/error';
			});
	}

	return (
		<div className='app-header'>
			<div className='logo-container'>
				<Link to='/' tabIndex={0}>
					<img src={CITLogo} alt='CI&T Logo' className='logo' />
				</Link>
			</div>
			<Menu mode='horizontal' className='header-menu'>
				{!isSessionUserTI && (
					<Menu.Item>
						<Link to='/profile' tabIndex={0}>
							{t('peopleTitle')}
						</Link>
					</Menu.Item>
				)}
				{!isSessionUserTI && !isSessionUserBP && (
					<Menu.Item>
						<Link to='/opportunity' tabIndex={0}>
							{t('needsTitle')}
						</Link>
					</Menu.Item>
				)}
				<Menu.Item>
					<ReportsSelector />
				</Menu.Item>
				{canSeeResponsible && (
					<Menu.Item>
						<Link to='/responsibles' tabIndex={0}>
							{t('responsibleTitle')}
						</Link>
					</Menu.Item>
				)}
				<FontSizeChanger />
				<Menu.Item className="menu-item-spaced">
					<LanguageSelector />
				</Menu.Item>
				<Menu.Item className="menu-item-spaced">
					<NotificationIcon />
				</Menu.Item>
				<Menu.Item
					onClick={onLogout}
					onKeyDown={(event) => {
						if (event.key === 'Enter' || event.key === ' ') {
							onLogout();
						}
					}}
					className='logout-outlined-button'
					aria-label={t('logoutTooltip')}
					role='button'
					type='button'
					title={t('logoutTooltip')}
					tabIndex={0}
				>
					<Tooltip
						title={t('logoutTooltip')}
						placement='bottomRight'
						arrow={false}
					>
						<LogoutOutlined
							alt='Logout'
							style={{ fontSize: 20, cursor: 'pointer' }}
						/>
					</Tooltip>
				</Menu.Item>
			</Menu>
		</div>
	);
}

export default Header;
